import React, {Component} from 'react';

import _ from "lodash";
import swal from 'sweetalert2';
import axios from "axios/index";

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import translator from "../../../../utils/translations";
import {ajaxHandler} from "../../../../utils/errors";
import {Spinner} from "../../../../components/Loading/Spinner";

export default class MeterForm extends Component {

    constructor(props) {
        super(props);

        let activeState = {
            id: null,
            code: '',
            product: '',
            description: '',
            loading_island: '',
        };

        if (this.props.item) {
            let meter = this.props.item;
            activeState = {
                id: meter.id,
                code: meter.code,
                description: meter.description,
                product: meter.product.id,
                loading_island: meter.loading_island.id
            };
        }

        this.state = {
            ...activeState,
            ajaxInProgress: false,
            products: false,
            loading_islands: false
        };
    }

    componentDidMount(){
        this._fetchOptions();
    }

    _initializeHTML = () => {
        window.initializeSelects('.admin-modal');
        window.bindSelectAction(this.productSelect, this._handleSelectChange);
        window.bindSelectAction(this.islandSelect, this._handleSelectChange);
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        let prop = target.getAttribute('data-state-var');
        this.setState({[prop]: target.value});
    };

    _fetchOptions = () => {
        const PRODUCT_URL = `${urls.API_ROOT}/api/v1/product/`;
        const ISLAND_URL = `${urls.API_ROOT}/api/v1/loadingislands/`;
        axios.all([
            axios.get(PRODUCT_URL, tokenHeader()),
            axios.get(ISLAND_URL, tokenHeader())
        ])
            .then(axios.spread(function (product, island) {
                return {
                    products: product,
                    islands: island
                }
            }))
            .then((data) => {
                let loading_islands = data.islands.data;
                loading_islands = loading_islands.sort((a, b) => {
                    return (a.terminal.name > b.terminal.name) ? 1 : -1
                });
                this.setState({
                    loading_islands,
                    products: data.products.data.filter(p => p.trip_type === 'FE')
                }, this._initializeHTML);
            })
            .catch((error) => ajaxHandler(error));
    };

    _handleInput = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleToggle = (prop, value) => {
        this.setState({[prop]: value});
    };

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let excludedKeys = ['ajaxInProgress', 'id', 'products', 'loading_islands'];

        let data = _.omit(this.state, excludedKeys);
        Object.keys(data).forEach(key => {if (data[key] === ''){data[key] = null;}});

        if(this.state.id){
            const UPDATE_TERMINAL = `${urls.API_ROOT}/api/v1/meters/id/${this.state.id}/`;
            axios.put(`${UPDATE_TERMINAL}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }else{
            const NEW_TERMINAL = `${urls.API_ROOT}/api/v1/meters/`;
            axios.post(`${NEW_TERMINAL}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }
    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false});

        swal({
            title: `Meter ${this.state.id ? 'actualizado' : 'creado'}`,
            html: 'La información ingresada ha sigo guardada correctamente',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
        });

        this.props.closeAction();
        this.props.refreshAction();
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido guardar la información del meter',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    render() {

        if(!this.state.loading_islands || !this.state.products){
            return (
                <div className={"admin-modal"}>
                    <Spinner />
                </div>
            );
        }

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{this.state.id ? 'Edición de Meter' : 'Alta Meter'}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.code} type={"text"}
                               onChange={(ev) => this._handleInput('code', ev.target.value)}
                        />
                        <label className="active">Código</label>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <input placeholder={"Ingrese un valor"} value={this.state.description} type={"text"}
                               onChange={(ev) => this._handleInput('description', ev.target.value)}
                        />
                        <label className="active">Descripción</label>
                    </div>
                </div>
                <div className={'col s12 input-field'}>
                    <select defaultValue={this.state.product} data-state-var="product"
                            ref={ref => {this.productSelect = ref}}>
                        <option className="select-option" value="">Seleccione una opción</option>
                        {this.state.products && this.state.products.map(product => {
                            return <option key={product.id} id={product.id}
                                           value={product.id}>{product.name}</option>
                        })}
                    </select>
                    <label>Producto</label>
                </div>
                <div className={'col s12 input-field'}>
                    <select defaultValue={this.state.loading_island} data-state-var="loading_island"
                            ref={ref => {this.islandSelect = ref}}>
                        <option className="select-option" value="">Seleccione una opción</option>
                        {this.state.loading_islands && this.state.loading_islands.map(island => {
                            return <option key={island.id} id={island.id}
                                           value={island.id}>{island.name} - {island.code} - {island.terminal.name}</option>
                        })}
                    </select>
                    <label>Isla de Descarga</label>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={`btn btn-shell-empty z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={`btn btn-shell z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this._submitForm}
                        >Guardar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/MeterForm.js